import { IContactAddressState } from '@r1-frontend/entities/ContactAddress/initialState';

import { getAddressByStr } from './helpers';

export const selectAddressByString = (state: IContactAddressState): string => {
    const {
        contactAddress: {
            editedAddressData: address,
        },
    } = state;

    return getAddressByStr(address);
};
